import { LocationMarkerIcon, MailIcon, PhoneIcon } from '@heroicons/react/solid'
import React from 'react'

function PersonalDetail({ personalDetail }) {
    const { address, email, phone, photo, fullName } = personalDetail
    return (
        <>
            <div className=''>
                <div className='personalDetail-name resume-center mb-2'>
                    <span className='resume-text-base text-center text-white font-bold'>{fullName}</span>
                </div>
                {!photo.isHidden && <div className='profile-width rounded-full overflow-hidden mx-auto'>
                    <img src={photo.link} alt="profile_img" />
                </div>}
                <div>
                    <div className='flex w-full flex-wrap justify-center text-center mt-3'>
                        <div className='block mx-0 bg-transparent break-words pb-2 leading-3'>
                            <span className='icon-align-default resume-icon'>
                                <LocationMarkerIcon className='w-4 mr-2' fill='#fff' />
                            </span>
                            <small className='text-xs text-white'>{address.addressDisplay}</small>
                        </div>
                        <div className='block mx-0 bg-transparent break-words pb-2 leading-3'>
                            <span className='icon-align-default'>
                                <MailIcon className='w-4  mr-2' fill='#fff' />
                            </span>
                            <small className='text-xs text-white'>{email.emailDisplay}</small>
                        </div>
                        <div className='block mx-0 bg-transparent break-words pb-2 leading-3'>
                            <span className='icon-align-default'>
                                <PhoneIcon className='w-4 mr-2' fill='#fff' />
                            </span>
                            <small className='text-xs text-white'>{phone.phoneDisplay}</small>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PersonalDetail